export var isPmPartnersEnabled = function () { return process.env.REACT_APP_DISABLE_FEATURE !== 'true'; };
export var SECTION_NAV_ITEMS = [
    {
        sectionKey: 'home',
        label: 'Home',
        path: '/',
        analyticsKey: 'home',
        showInBumper: true,
        showInHeaderStrip: true,
    },
    {
        sectionKey: 'locations',
        label: 'Locations',
        path: '/truck-parking',
        analyticsKey: 'locations',
        showInBumper: true,
        showInHeaderStrip: true,
    },
    {
        sectionKey: 'rates',
        label: 'Rates',
        path: '/rates',
        analyticsKey: 'rates',
        showInBumper: true,
        showInHeaderStrip: true,
    },
    {
        sectionKey: 'pm_partners',
        label: 'PM Services',
        path: '/pm-partners',
        analyticsKey: 'pm_partners',
        showInBumper: true,
        showInHeaderStrip: true,
    },
    {
        sectionKey: 'about',
        label: 'About',
        path: '/about',
        analyticsKey: 'about',
        showInBumper: true,
        showInHeaderStrip: true,
    },
];
export var SECTION_PATHS = SECTION_NAV_ITEMS.reduce(function (acc, item) {
    acc[item.sectionKey] = item.path;
    return acc;
}, {
    home: '/',
    locations: '/truck-parking',
    rates: '/rates',
    about: '/about',
    pm_partners: '/pm-partners',
});
var HEADER_NAV_HIDE_PATTERNS = [
    /^\/admin(?:\/|$)/i,
    /^\/manager(?:\/|$)/i,
    /^\/dashboard(?:\/|$)/i,
    /^\/settings(?:\/|$)/i,
    /^\/profile(?:\/|$)/i,
    /^\/login(?:\/|$)/i,
    /^\/signin(?:\/|$)/i,
    /^\/callback(?:\/|$)/i,
    /^\/auth(?:\/|$)/i,
    /^\/m(?:\/|$)/i,
    /^\/extend(?:\/|$)/i,
    /^\/my-bookings(?:\/|$)/i,
    /^\/checkout(?:\/|$)/i,
    /^\/manage-booking(?:\/|$)/i,
    /^\/booking-details(?:\/|$)/i,
    /^\/link-expired(?:\/|$)/i,
    /^\/spot-changes(?:\/|$)/i,
    /^\/hiring(?:\/|$)/i,
];
var normalizePathname = function (pathname) {
    if (pathname === void 0) { pathname = ''; }
    if (!pathname)
        return '/';
    if (pathname === '/')
        return '/';
    return pathname.replace(/\/+$/, '') || '/';
};
export var getSectionByPath = function (pathname) {
    if (pathname === void 0) { pathname = ''; }
    var normalizedPath = normalizePathname(pathname);
    var staticMatch = SECTION_NAV_ITEMS.find(function (item) { return item.path === normalizedPath; });
    if (staticMatch)
        return staticMatch;
    if (/^\/locations\/[^/]+$/i.test(normalizedPath)
        || /^\/truck-parking(?:\/[^/]+){1,3}$/i.test(normalizedPath)) {
        return SECTION_NAV_ITEMS.find(function (item) { return item.sectionKey === 'locations'; });
    }
    if (/^\/pm-partners\/[^/]+$/i.test(normalizedPath)
        || /^\/truck-repair-and-maintenance(?:\/|$)/i.test(normalizedPath)) {
        return SECTION_NAV_ITEMS.find(function (item) { return item.sectionKey === 'pm_partners'; });
    }
    if (/^\/truck-parking\/last-hour-parking(?:\/|$)?/i.test(normalizedPath)) {
        return SECTION_NAV_ITEMS.find(function (item) { return item.sectionKey === 'locations'; });
    }
    return undefined;
};
export var getPathBySection = function (sectionKey) {
    return SECTION_PATHS[sectionKey] || '/';
};
export var isHomeShellRoute = function (pathname) {
    if (pathname === void 0) { pathname = ''; }
    return Boolean(getSectionByPath(pathname));
};
export var shouldShowHeaderSectionNav = function (pathname) {
    if (pathname === void 0) { pathname = ''; }
    var normalizedPath = normalizePathname(pathname);
    return !HEADER_NAV_HIDE_PATTERNS.some(function (pattern) { return pattern.test(normalizedPath); });
};
export var normalizeSectionKey = function (value) {
    if (!value)
        return null;
    var normalizedValue = value.trim().toLowerCase();
    if (!normalizedValue)
        return null;
    if (normalizedValue === 'home')
        return 'home';
    if (normalizedValue === 'locations')
        return 'locations';
    if (normalizedValue === 'rates')
        return 'rates';
    if (normalizedValue === 'about')
        return 'about';
    if (normalizedValue === 'pm_partners' ||
        normalizedValue === 'pm-partners' ||
        normalizedValue === 'pm_services' ||
        normalizedValue === 'pm services' ||
        normalizedValue === 'services' ||
        normalizedValue === 'caromeck' ||
        normalizedValue === 'pm_partners_hub') {
        return 'pm_partners';
    }
    return null;
};
export default {
    SECTION_NAV_ITEMS: SECTION_NAV_ITEMS,
    SECTION_PATHS: SECTION_PATHS,
    isPmPartnersEnabled: isPmPartnersEnabled,
    getSectionByPath: getSectionByPath,
    getPathBySection: getPathBySection,
    shouldShowHeaderSectionNav: shouldShowHeaderSectionNav,
    isHomeShellRoute: isHomeShellRoute,
    normalizeSectionKey: normalizeSectionKey,
};
